const token=()=>{
 if(localStorage.getItem("auth_token")){
    return true;
 }
 return false;
}

export default token